import { render, staticRenderFns } from "./GuestioConnect.vue?vue&type=template&id=22bb2ec2&scoped=true"
import script from "./GuestioConnect.vue?vue&type=script&lang=js"
export * from "./GuestioConnect.vue?vue&type=script&lang=js"
import style0 from "./GuestioConnect.vue?vue&type=style&index=0&id=22bb2ec2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bb2ec2",
  null
  
)

export default component.exports